/* loaded by smart-asset */
export default require("./user~bpQNyvzg.png")